import React, { FC, useRef, useState } from 'react';
import IdleTimer from 'react-idle-timer';
import RefreshModal from '../RefreshModal';
import Props from './typing';
import useRedirect from '../../../hooks/useRedirect';
import { useDispatch, useSelector } from 'react-redux';
import { clearMerchantInfoAction } from '../../../redux/actions/login';

const IdleTimerContainer: FC<Props> = (props) => {
  const { location } = useRedirect();
  const { pathname: pathName } = location;
  const [isRefreshPopup, setRefreshPopup] = useState<boolean>(false);
  const isAdmin = useSelector(
    (state: any) => state?.loginReducer?.loginState?.isAdmin
  );
  const dispatch = useDispatch();
  //const [idleTimerRef, setIdleTimerRef] = useState(null);

  //const idleTimerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);

  const onIdle = () => {
    setRefreshPopup(true);
    sessionTimeoutRef.current = setTimeout(
      onLogoutClickHandler,
      props.afterIdleHardLogoutTime
    );
  };

  const onLogoutClickHandler = () => {
    props.logoutAction();
    setRefreshPopup(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  const onOkClickHandler = () => {
    setRefreshPopup(false);
    isAdmin? dispatch(clearMerchantInfoAction({})) : props.refreshTokenAction({ pathName: pathName?.split('/')[1] });
    clearTimeout(sessionTimeoutRef.current);
  };

  return (
    <React.Fragment>
      <IdleTimer
        //ref={(ref) => setIdleTimerRef(ref)}
        timeout={props.idleTimeout}
        onIdle={onIdle}
        crossTab={{
          emitOnAllTabs: true,
        }}
      />

      {isRefreshPopup && (
        <RefreshModal
          onLogoutClickHandler={onLogoutClickHandler}
          onOkClickHandler={onOkClickHandler}
        />
      )}
    </React.Fragment>
  );
};

export default IdleTimerContainer;
